import type invitationZh from '../zh/invitation';

const invitation: typeof invitationZh = {
  title: 'Invitations',
  create_target: 'Create targeted invitation',
  create_target_soon: 'Opening TikTok Shop to create a Target Collab',
  cleanup: 'Clean up invitations',
  merge_groups: 'Merge invitation groups',
  add_talent: 'Add creators',
  remove_talent: 'Remove creators',
  remove_talent_soon: 'Remove creators from the selected invitations',
  remove_talent_title: 'Remove creators who have not accepted',
  remove_talent_hint:
    'Creators are loaded from the invitation details first. Accepted and not accepted come from the creator label. The request may still skip some and return a reason.',
  label_accepted: 'Accepted',
  label_unaccepted: 'Not accepted',
  label_ordered: 'Ordered',
  remove_talent_failed: 'Could not remove creators',
  remove_talent_success: 'Creator removal submitted',
  remove_no_unaccepted: 'No creators are waiting to accept this invitation',
  cleanup_remove_none: 'No creators left to remove',
  add_product: 'Add products',
  kaloboost_hint: 'Like Kaloboost: invitations follow the shop Target Collab and do not use DM quota',
  status_tabs: 'Invitation status',
  col_name: 'Invitation name (TikTok Shop)',
  col_status: 'Status',
  col_product: 'Products',
  col_deadline: 'Deadline',
  col_added: 'Creators added',
  col_accepted: 'Accepted',
  col_fulfilled: 'Fulfilled',
  col_actions: 'Actions',
  filter_all: 'All',
  name_placeholder: 'Search invitation name',
  submit_status: 'Submit status',
  filter_ongoing: 'Ongoing',
  filter_closed: 'Closed',
  filter_cancelled: 'Cancelled',
  status_expiring: 'Expiring',
  status_valid: 'Valid',
  status_canceling: 'Canceling',
  status_completed: 'Completed',
  submit_submitting: 'Submitting',
  submit_success: 'Submitted',
  submit_failed: 'Failed',
  submit_unknown: 'Unknown',
  load_failed: 'Failed to load invitations',
  batch_invite_hint: 'Up to 10 invitations. Blacklisted creators and creators already in an invitation are skipped.',
  invite_shop_required: 'Select a shop first',
  invite_pick_required: 'Select invitations',
  invite_options_failed: 'Failed to load invitations',
  invite_success: 'Batch invite submitted',
  invite_failed: 'Batch invite failed',
  refreshed: 'Shop product list refreshed',
  pick_product: 'Select at least one product',
  product_list_unavailable: 'The product list API is not connected yet',
  add_products_failed: 'Could not add products',
  add_products_success: 'Products added',
  add_products_limit: 'Select at most 10 invitations',
  invite_limit: 'Select at most 10 invitations',
  target_named: '"{{name}}"',
  target_current: 'the current invitation',
  added_products: 'Added {{count}} products to {{target}}',
  add_product_title: 'Add products to invitation',
  product_hint:
    'Only products available in the authorized shop. Commission defaults to the open invitation rate and can be adjusted for this targeted invitation.',
  current_shop: 'Current shop',
  rate_adjustable: 'Commission defaults to the open invitation rate and can be adjusted',
  refresh: 'Refresh',
  public_rate: '{{sku}} · {{price}} · Open invitation {{rate}}%',
  target_commission: 'Targeted commission',
  has_email: 'Has email',
  no_email: 'No email',
  pick_talent: 'Select at least one creator',
  added_talents: 'Added {{count}} creators to {{target}}',
  add_talent_title: 'Add creators to invitation',
  add: 'Add',
  talent_hint:
    'Prefer creators from My Creators. Blacklist, creators already in the invitation, and conflict locks are skipped automatically.',
  none_selected: 'No creators selected. Pick from My Creators, or search the square to add more.',
  selected_count: '{{count}} creators selected',
  selected_named: '{{count}} creators selected · {{name}}',
  search_placeholder: 'Search my creators, or enter a name / @handle to search the square',
  my_talents: 'My creators ({{count}})',
  search_square: 'Search square',
  paste_list: 'Paste list',
  select_all: 'Select all results',
  paste_placeholder: 'One name or @handle per line',
  square_prompt: 'Enter a name or @handle to search creators in the square',
  no_match: 'No matching creators',
  mode_clear_title: 'Remove unaccepted creators and cancel empty invitations',
  mode_clear_desc:
    'Only unaccepted creators are removed. Accepted creators stay. Invitations with no products and zero acceptances are cancelled automatically.',
  mode_cancel_title: 'Cancel invitation plan',
  mode_cancel_desc: 'Ends the entire Target Collab even if creators have already accepted. Requires a second confirmation.',
  cleaned: 'Cleanup finished: {{mode}}',
  cleaned_whitelist: 'Cleanup finished: {{mode}} (whitelist {{count}})',
  confirm_cancel_title: 'Cancel this invitation plan?',
  confirm_cancel_content:
    'This ends the entire Target Collab even if creators have already accepted. This cannot be undone.',
  confirm_cancel_ok: 'Confirm cancel',
  confirm_cancel_back: 'Back',
  cancel_plan_failed: 'Could not cancel the invitation plan',
  cancel_plan_success: 'Invitation plan cancelled',
  run_cleanup: 'Run cleanup',
  choose_method: 'Cleanup method',
  whitelist_title: 'Creators to keep (whitelist)',
  whitelist_summary: '{{count}} creators on the whitelist (kept during cleanup)',
  stat_added: 'Added',
  deadline_at: 'Deadline {{date}}',
  talents: 'Creators',
  accepted_note: 'Accepted creators enter fulfillment;',
  pending_note: 'Unaccepted creators can be cleaned up. This does not use DM quota.',
  detail_title: 'Invitation details',
  detail_load_failed: 'Could not load invitation details',
  detail_empty: 'No invitation details',
  detail_empty_talents: 'No creators',
  detail_content_products: 'Content products',
  detail_empty_products: 'No products',
  detail_empty_operations: 'No operations',
  detail_sync_pending: 'The latest read from the platform did not finish. Counts below may not be current.',
  detail_failed_reason: 'Failure reason',
  detail_submit_failed: 'Submission failed: {{reason}}',
  detail_shop_id: 'Shop ID',
  detail_deadline: 'Deadline',
  detail_free_sample: 'Free sample',
  detail_sample_exempt: 'Approval exempt',
  detail_content_type: 'Content type',
  detail_operations: 'Operations',
  detail_op_failed: 'Latest operation failed',
  detail_request_id: 'Platform request ID',
  detail_yes: 'Yes',
  detail_no: 'No',
  pick_primary: 'Select the primary invitation',
  pick_deadline: 'Select the deadline after merge',
  pick_two: 'Select at least 2 ongoing and unlocked invitations',
  merged: 'Merged {{count}} invitations into "{{name}}", deadline {{date}}',
  merge_failed: 'Could not merge invitations',
  merge_success: 'Invitations merged',
  merge_end_invalid: 'The deadline must be later than now',
  merge: 'Merge',
  merge_hint:
    'Merge ongoing, unlocked targeted invitations into one. Creators and products are deduped into the primary invitation.',
  too_few: 'At least 2 selected invitations must be Ongoing and unlocked before they can be merged.',
  primary: 'Primary invitation',
  primary_placeholder: 'Select primary invitation',
  deadline_after: 'Deadline after merge',
  channel_email: 'Platform email',
  channel_dm: 'Direct message',
  script_sample: 'New product sample',
  script_invite: 'Targeted invitation',
  script_follow: 'Follow-up',
  outreach_created: 'Outreach task created ({{count}} creators)',
  outreach_title: 'Quick outreach',
  create_task: 'Create task',
  task_name: 'Task name',
  task_name_placeholder: 'Defaults to "Email task"',
  mail_subject: 'Subject',
  mail_subject_placeholder: 'Enter the email subject',
  mail_body: 'Body',
  mail_body_placeholder: 'Enter the email body',
  template_placeholder: 'Optional. Email scripts for the current shop',
  template_load_failed: 'Could not load script templates',
  campaign_subject_required: 'Enter an email subject',
  campaign_body_required: 'Enter the email body',
  campaign_no_email: 'None of the selected creators have an email address',
  campaign_skipped_email: 'Skipped {{count}} creators without an email address',
  campaign_failed: 'Could not create the email task',
  campaign_created: 'Email task created',
  dm_failed: 'Could not create the direct-message conversation',
  dm_missing_conversation: 'No conversation id was returned',
  dm_created: 'Direct-message conversation created',
  channel: 'Channel',
  script_or_invite: 'Script / invitation',
  select_talent: 'Select creators',
  all_count: 'All ({{count}})',
  empty_selected: 'No creators selected yet. Pick them from another tab.',
  batch_count: 'Batch {{count}}',
  joined: 'Added to targeted invitation: {{name}}',
  join_title: 'Add to targeted invitation',
  join_title_named: 'Add to targeted invitation · {{name}}',
  invite: 'Invitation',
  target_hint: 'Writes to the current shop Target Collab. Blacklist and conflict locks are checked.',
  invite_list: 'Invitation list',
  invite_list_placeholder: 'Select an invitation',
  create_name: 'Invitation name',
  create_name_placeholder: 'e.g. VN Vitamin C serum · October',
  create_deadline: 'Deadline',
  mounted_products: 'Products',
  product_load_failed: 'Could not load shop products',
  product_pick_invite: 'Select an invitation first',
  product_empty: 'No sellable products in this shop',
  product_keyword: 'Search product name',
  product_refreshed: 'Shop products refreshed',
  add_talent_section: 'Add creators (quick pick from My creators)',
  talent_default_hint:
    'Only My creators are loaded by default. Search the square to add others; the full square is not loaded.',
  submit_invite: 'Submit invitation',
  submit_invite_note:
    'Submitting creates a TikTok Shop Target Collab. Creators see it on the Seller / Affiliate side and enter fulfillment after accepting. The shop must be authorized. Blacklisted creators are not listed.',
  create_name_required: 'Enter an invitation name',
  create_deadline_required: 'Choose a deadline',
  contact_email: 'Contact email',
  contact_email_placeholder: 'Enter a contact email',
  contact_email_required: 'Enter a contact email',
  invite_message: 'Invitation message',
  invite_message_placeholder: 'Optional',
  commission_required: 'Enter a commission of 0 or more',
  product_id_invalid: 'Product ID is required and must be 64 characters or fewer',
  create_failed: 'Could not create the invitation',
  create_success: 'Invitation created',
  create_skipped: 'Skipped {{count}} creators'
};

export default invitation;
